import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../../../shared/util/angularEditorConfig";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { SolicitacaoTecnicaService } from "../../../../../services/solicitacao-tecnica.service";
import { AuthService } from "../../../../../services/auth.service";
import { ISolicitacaoTecnicaModel } from "../../../../../models/solicitacao-tecnica.model";
import { INotaAuditoriaExecucaoModel } from "../../../../../models/nota-auditoria-execucao.model";
import { MatTableDataSource } from "@angular/material/table";
import { IItemSolicitacaoTecnicaModel } from "../../../../../models/item-solicitacao-tecnica.model";
import { INotaItemAuditoriaExecucaoModel } from "../../../../../models/nota-item-auditoria-execucao.model";
import { SharedService } from "../../../../../services/shared.service";
import { NotaAuditoriaExecucaoService } from "../../../../../services/nota-auditoria-execucao.service";
import Swal from "sweetalert2";
import {
  ModalIncluirItemNotaAuditoriaExecucaoComponent
} from "../modal-incluir-nota-item/modal-incluir-item-nota-auditoria-execucao.component";
import {
  ModalJustificativaComponent
} from "../../../../../shared/components/modal-justificativa/modal-justificativa.component";
import { ModalCancelarComponent } from "../../../../../shared/components/modal-cancelar/modal-cancelar-component";


@Component({
  selector: "app-aba-modal-incluir-nota-execucao",
  templateUrl: "./modal-incluir-nota-execucao.component.html",
  styleUrls: ["./modal-incluir-nota-execucao.component.scss"],
})

export class ModalIncluirNotaExecucaoComponent implements OnInit, AfterViewInit {
  public editorConfig: AngularEditorConfig = angularEditorConfig(
    "Digite a descrição",
    "200px",
    "100%"
  );

  public visualizar: boolean;
  public titulo: string = "";
  public submitted: boolean;
  public numeroST: string;
  public editorMaxLength = 2000;
  public dataHoje: Date = this.truncateDate(new Date());
  public acaoCancelarItem: boolean;
  public model: INotaAuditoriaExecucaoModel = {} as INotaAuditoriaExecucaoModel;
  public dataPrazoLimite: Date;
  public dataSourceItems = new MatTableDataSource<INotaItemAuditoriaExecucaoModel>([]);
  valorOriginal!: any;
  habilitaFinalizarEnviar: boolean = false;
  public incluirNotaAuditoria: FormGroup = this.fb.group({
    assunto: ["", Validators.required],
    descricao: ["", Validators.required],
    nomeResponsavel: ["", Validators.required],
    cargoResponsavel: ["", Validators.required],
    prazoResposta: ["", [Validators.required, this.dateRangeValidator.bind(this)]],
  });
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
    public notaAuditoriaExecucaoService: NotaAuditoriaExecucaoService,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<ModalIncluirNotaExecucaoComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    if (data?.id) {
      this.model.id = data.id;
    }

    this.visualizar = data?.visualizar;
    this.titulo = data?.titulo;
    this.model.status = data?.status;
    this.model.documentoAssociado = data?.documentoAssociado;
    this.numeroST = data?.numeroST;
    this.dataPrazoLimite = this.truncateDate(data?.dataLimite);
    this.acaoCancelarItem = data?.acaoCancelarItem;
  }

  ngOnInit(): void {
    this.dataSourceItems.paginator = this.paginator;
    this.dataSourceItems.sort = this.sort;
    this.dataSourceItems.sortingDataAccessor = this.sortingDataAccessor;

    this.incluirNotaAuditoria.valueChanges.subscribe(() => {
      if (this.valorOriginal && !this.formsIguais(this.valorOriginal, this.incluirNotaAuditoria.value)) {
        this.habilitaFinalizarEnviar = false;
      }
      else {
        this.habilitaFinalizarEnviar = true;
      }
    });

    // Carrega os dados se houver um ID
    if (this.model?.id) {
      this.obterPorId();
    }
  }

  ngAfterViewInit() {
    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 2000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "ug":
        return item?.unidadeGestora?.text;
      case "responsavel":
        return item?.responsavel?.text;
      case "tituloItem":
        return item?.titulo;
      case "numero":
        return item?.numero;
      case "status":
        return item?.status?.descricao;
      default:
        return item[property];
    }
  };

  onEditorChange(content: string) {
    if (content.length > this.editorMaxLength) {
      this.incluirNotaAuditoria.get('descricao')?.setValue(content.substring(0, this.editorMaxLength), { emitEvent: false });
    }
  }

  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  isStatusAvaliacaoVazio(statusAvaliacao: any): boolean {
    return !statusAvaliacao || statusAvaliacao === null || statusAvaliacao === undefined;
  }

  formatarTooltipAvaliacao(element: any): string {
    const data = element?.dataHoraAvaliacao
      ? new Date(element.dataHoraAvaliacao).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelNomeAvaliacao || 'Avaliador desconhecido';
    const comentario = element?.comentarioAvaliacao || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }

  formatarTooltipCanc(element: any): string {
    const data = element?.dataHoraCanc
      ? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
    const comentario = element?.justificativa || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }

  private formsIguais(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  public cancelar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { interno: true };

    if (this.visualizar) {
      this.matDialog.closeAll();
    } else {
      this.matDialog
        .open(ModalCancelarComponent, dialogConfig)
        .afterClosed();
    }
  }

  public avaliar() {
    this.dialogRef.close();
  }

  dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;

    const selectedDate = this.truncateDate(new Date(control.value));

    if (selectedDate < this.dataHoje) {
      return { dataMenorHoje: true };
    }
    //
    // if (this.dataPrazoLimite && selectedDate > this.dataPrazoLimite) {
    //   return { dataMaiorLimite: true };
    // }

    return null;
  }

  public obterPorId(): void {
    if (!this.model?.id) {
      return;
    }

    this.notaAuditoriaExecucaoService.obterPorId(this.model.id).then((res) => {

      if (res.sucesso && res.dados) {
        const dados = res.dados;
        // Popula a tabela de itens
        this.dataSourceItems = new MatTableDataSource<INotaItemAuditoriaExecucaoModel>(
          dados.item || []
        );

        // Popula os campos do formulário
        this.incluirNotaAuditoria.patchValue({
          prazoResposta: dados.prazo ? new Date(dados.prazo) : null,
          assunto: dados.assunto,
          descricao: dados.descricao,
          nomeResponsavel: dados.nomeResponsavel,
          cargoResponsavel: dados.cargoResponsavel
        });

        // Atualiza o model
        this.model.id = dados.id;
        this.model.numero = dados.numero;
        this.model.status = dados.status;
        this.model.assunto = dados.assunto;
        this.model.descricao = dados.descricao;
        this.model.prazo = dados.prazo;
        this.model.nomeResponsavel = dados.nomeResponsavel;
        this.model.cargoResponsavel = dados.cargoResponsavel;
        this.model.documentoAssociado = dados.documentoAssociado;
        this.model.unidadeGestoraSigla = dados.unidadeGestoraSigla;
        this.model.DataLimite = dados.DataLimite;
        this.model.item = dados.item;
        this.model.prorrogarNotaAuditoriaExecucao = dados.prorrogarNotaAuditoriaExecucao;
        this.model.responsavelIdCanc = dados.responsavelIdCanc;
        this.model.responsavelCanc = dados.responsavelCanc;
        this.model.dataHoraCanc = dados.dataHoraCanc;
        this.model.justificativa = dados.justificativa;

        // Configura paginação e ordenação
        this.dataSourceItems.paginator = this.paginator;
        this.dataSourceItems.sort = this.sort;

        // Salva valor original para comparação
        this.valorOriginal = this.incluirNotaAuditoria.getRawValue();
        this.habilitaFinalizarEnviar = true;

        // Desabilita campos se for visualização
        if (this.visualizar) {
          this.incluirNotaAuditoria.disable();
        } else {
          this.incluirNotaAuditoria.enable();
        }

      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem?.descricao || 'Registro não encontrado',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    }).catch((err) => {
      console.error('Erro:', err);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem?.descricao || 'Erro ao buscar dados',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    });
  }

  public cancelarItem(itemId: number): void {
    // Implementar lógica de cancelamento do item
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";
    dialogConfig.width = "45vw";
    dialogConfig.maxHeight = "85vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = false;
    dialogConfig.data = {};
    const modal = this.matDialog.open(
      ModalJustificativaComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((justificativa) => {
      if (justificativa) {

        const responsavelId = this.authService.usuario.id;

        console.log(responsavelId);

        this.notaAuditoriaExecucaoService
          .cancelarItem(this.model?.id, itemId, justificativa, responsavelId)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              text: err.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
            this.obterPorId()
          });
      }
    });
  }

  public modalIncluiritem(
    titulo: string,
    visualizar: boolean,
    element?: INotaItemAuditoriaExecucaoModel
  ) {
    if (!this.model?.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        title: "Atenção",
        icon: "warning",
        text: "Antes, salve as informações!",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.salvar(true)
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "modal-component-item-auditoria";
      dialogConfig.width = '80%';
      dialogConfig.height = '90%';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        titulo,
        visualizar,
        id: this.model?.id,
        numeroNotaAuditoria: this.model.numero ,
        resposavel: this.model.nomeResponsavel ,
        documentoAssociado : this.model.documentoAssociado,
        notaAuditoriaExecucaoId : this.model?.id,
        element
      };
      const modal = this.matDialog.open(
        ModalIncluirItemNotaAuditoriaExecucaoComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe((data) => {
        if (data) {
          this.obterPorId()
        }
      });
    }
  }

  public excluirItem(id: number) {
    Swal.fire({
      title: "Excluir Registro",
      text: "Tem certeza que deseja excluir esse Registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.notaAuditoriaExecucaoService
          .excluirItem(this.model?.id, id)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              text: err.mensagem.descricao,
              icon: "error",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
            this.obterPorId()
          });
      }
    });
  }

  public enviar() {

    this.notaAuditoriaExecucaoService
      .enviar(this.model?.id)
      .then((res) => {
        if (res.sucesso) {
          this.model.status = res?.dados?.status;
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.dialogRef.close()
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public finalizar() {
    this.notaAuditoriaExecucaoService
      .finalizar(this.model?.id)
      .then((res) => {
        if (res.sucesso) {
          this.model.status = res?.dados?.status;
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public salvar(exibirModalAdicionarItem?: boolean): void {
    this.submitted = true;

    if (this.incluirNotaAuditoria.invalid) {
      return;
    }

    const dados = {
      id: this.model?.id,
      osaExecucaoId: this.data?.osaExecucaoId,
      prazo: this.incluirNotaAuditoria.get("prazoResposta")?.value,
      assunto: this.incluirNotaAuditoria.get("assunto")?.value,
      descricao: this.incluirNotaAuditoria.get("descricao")?.value,
      nomeResponsavel: this.incluirNotaAuditoria.get("nomeResponsavel")?.value,
      cargoResponsavel: this.incluirNotaAuditoria.get("cargoResponsavel")?.value,
    } as INotaAuditoriaExecucaoModel;

    console.log(dados);

    this.notaAuditoriaExecucaoService
      .salvarNotaAuditoriaExecucao(dados)
      .then((res) => {
        if (res.sucesso) {
          this.model.id = res?.dados?.id;
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          if (exibirModalAdicionarItem) this.modalIncluiritem('Incluir', false);
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err.mensagem?.descricao || 'Erro ao salvar nota de auditoria',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      })
      .finally(() => {
        this.obterPorId();
      });
  }
}
